(function () {
  if (window.peOpeningHoursLoaded) return;
  window.peOpeningHoursLoaded = true;

  const DAY_ORDER = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function buildRows(weekdayDescriptions) {
    return DAY_ORDER.map((day) => {
      const entry = weekdayDescriptions.find((d) => d.startsWith(day));
      if (!entry) return '';
      const parts = entry.split(': ');
      const dayLabel = parts[0];
      let timeLabel = parts[1] || 'Closed';
      if (timeLabel !== 'Closed') {
        timeLabel = timeLabel.replace(/\s?(am|pm|AM|PM)/g, '');
      }
      return (
        '<div class="opening-hours__row">' +
        '<span class="opening-hours__day">' + escapeHtml(dayLabel) + '</span>' +
        '<span class="opening-hours__time">' + escapeHtml(timeLabel) + '</span>' +
        '</div>'
      );
    }).join('');
  }

  function showFallback(instance) {
    const skeleton = instance.querySelector('.opening-hours--skeleton');
    const fallback = instance.querySelector('.opening-hours--fallback');
    const unavailable = instance.querySelector('.opening-hours__unavailable');
    if (skeleton) skeleton.hidden = true;
    if (fallback && fallback.children.length > 0) {
      fallback.hidden = false;
    } else if (unavailable) {
      unavailable.hidden = false;
    }
  }

  function showLive(instance, html) {
    const skeleton = instance.querySelector('.opening-hours--skeleton');
    const live = instance.querySelector('.opening-hours--live');
    if (skeleton) skeleton.hidden = true;
    if (live) {
      live.innerHTML = html;
      live.hidden = false;
    }
  }

  function fetchHours(apiKey, placeId) {
    if (window.peOpeningHoursPromise) return window.peOpeningHoursPromise;
    const url = 'https://places.googleapis.com/v1/places/' + encodeURIComponent(placeId);
    window.peOpeningHoursPromise = fetch(url, {
      headers: {
        'X-Goog-Api-Key': apiKey,
        'X-Goog-FieldMask': 'regularOpeningHours'
      }
    }).then(async (r) => {
      if (!r.ok) {
        const body = await r.text();
        console.error('[opening-hours] Places API ' + r.status + ':', body);
        throw new Error('Places API ' + r.status);
      }
      return r.json();
    });
    return window.peOpeningHoursPromise;
  }

  function init() {
    const instances = document.querySelectorAll('[data-pe-opening-hours]');
    if (!instances.length) return;

    const cfg = window.peOpeningHoursConfig || {};
    if (!cfg.apiKey || !cfg.placeId) {
      console.warn('[opening-hours] missing apiKey or placeId — showing fallback');
      instances.forEach(showFallback);
      return;
    }

    fetchHours(cfg.apiKey, cfg.placeId)
      .then((data) => {
        const wd = data && data.regularOpeningHours && data.regularOpeningHours.weekdayDescriptions;
        if (!wd || !wd.length) {
          console.warn('[opening-hours] no weekdayDescriptions in response');
          instances.forEach(showFallback);
          return;
        }
        const html = buildRows(wd);
        instances.forEach((el) => showLive(el, html));
      })
      .catch((err) => {
        console.warn('[opening-hours] fetch failed:', err);
        instances.forEach(showFallback);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
